module.exports = __webpack_public_path__ + "img/video-conference.9f8a4316.png";